import styled from 'styled-components';
import { customMedia } from 'styles/utils';
import config from 'apps/project/config';

import Image from 'components/Image';

export const MainSectionWrapper = styled.div`
  position: relative;
  overflow: hidden;
  width: 92vw;
  height: calc((${config.ratio[1]} * 92vw) / ${config.ratio[0]});
  max-width: ${config.width}px;
  max-height: ${config.height}px;

  ${customMedia.greaterThan('sxlarge')`
    width: ${config.width}px;
    height: ${config.height}px;
  `}

  position: sticky;
  align-self: center;
`;

export const ImageStyled = styled(Image)`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const ProjectImageWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  border-left: 1px solid ${props => props.theme.color.wfGrey200};
  width: 92vw;
  height: calc((${config.ratio[1]} * 92vw) / ${config.ratio[0]});
  max-width: ${config.width}px;
  max-height: ${config.height}px;

  > div {
    min-height: ${config.height}px;
  }
  div.cropper * {
    min-height: ${config.height}px;
    max-height: ${config.height}px;
  }
  div.cropper-container * {
    min-height: ${config.height}px;
    max-height: ${config.height}px;
  }
  div.cropper-wrap-box * {
    min-height: ${config.height}px;
    max-height: ${config.height}px;
  }

  picture {
    width: 100%;
  }

  &:hover {
    > div > p {
      opacity: 1;
    }
  }

  ${customMedia.greaterThan('sxlarge')`
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    width: ${config.width}px;
    min-height: ${config.height}px;
  `}
`;
